import createImageIcon from './createImageIcon';
import path from './capacity.svg';

export default createImageIcon({displayName: 'CapacityIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/CapacityIcon.js